import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { hot } from "react-hot-loader";
import DateRangeControlCell from "./DateRangeControlCell";
import {
    StyledCard,
    StyledContent,
    StyledHeader,
} from "../../styles";
import Fullscreen from "react-fullscreen-crossbrowser";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import PrintIcon from "@material-ui/icons/Print";
import moment from "moment";
import Track from "./Track.js";
import ReactToPrint from "react-to-print";
import {
    getUsers,
    setClickedEventSegment,
    initialise,
    getIsLocked,
    setTrack,
    getPlannerInfo,
    getVehicles,
    getEquipment,
    setAreaFilter,
    setDepartmentFilter,
    getDepartments,
    getAreas,
    setIsLocked,
} from "./actions";
import {
    selectWeekCount,
    selectWeekDayStrings,
    selectIsLocked,
    selectTracks,
    selectAreas,
    selectAreaFilter,
    selectDepartmentFilter,
    selectDepartments,
    canCreate,
    canDelete,
    canUpdate,
} from "./selectors";
import AddEditEventModal from "./AddEditEventModal";
import {
    Button,
    FormControl,
    TextField,
    Select,
    InputLabel,
    MenuItem,
    Typography
} from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import AddIcon from "@material-ui/icons/Add";
import FSIcon from "@material-ui/icons/Fullscreen";
import FSEIcon from "@material-ui/icons/FullscreenExit";
const sidebarWidth = 150;
const AllTracksContainer = styled.div`
    grid-row-start: 3;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: ${(props) => props.weekCount * 7 + 2};
`;
const TimelineContainer = styled.div`
    grid-row: 1;
    grid-column: 1;
    width: 100%;
    height: auto;
    border-radius: 4px;
    display: grid;
    grid-template-rows: 20px 30px 1fr;
    grid-template-columns: ${sidebarWidth}px repeat(
            ${(props) => props.weekCount * 7},
            1fr
        );
    grid-gap: 2px;
    background-color: #0188cc;
    border: 2px solid #0188cc;
    border-radius: 4px;
    margin-bottom: 10px;
`;

const StyledCardContent = styled.div`
    position: relative;
    height: auto;
    padding: ${(props) => (props.isFull ? "10px" : "0px")};
    padding-bottom: ${(props) => (props.isFull ? "20px" : "0px")};
    display: grid;
    grid-template-rows: 60% 40%;
    grid-template-columns: 1fr;
    background: #0188cc;
`;

const DateCell = styled.div`
    width: 100%;
    text-align: center;
    padding-top: 2px;
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: ${(props) => props.day + 2};
    grid-column-end: ${(props) => props.day + 2};
    background-color: #0188cc;
    color: white;
    border-radius: 4px 4px 0 0;
`;

const DateText = styled.div`
    display: inline-block;
    font-size: 1.1em;
    font-family: "Nunito Sans", -apple-system, ".SFNSText-Regular",
        "San Francisco", BlinkMacSystemFont, "Segoe UI", "Helvetica Neue",
        Helvetica, Arial, sans-serif;
`;

const Print = styled.div`
    @media print {
        margin: 0;
        padding: 0;
        width: 140%;
        height: 100%;
        transform: rotate(270deg) translate(-580mm, 0);
        transform-origin: 0 0;
    }
`;

class WeekPlannerV2 extends React.Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getAreas();
        props.getDepartments();
        props.getIsLocked();
        props.getVehicles();
        props.getEquipment();
        props.getPlannerInfo();
        this.state = {
            isFull: false,
            track_modal: false,
            track_details: false,
            newTrack: true,
            AddEditModalOpen: false,
            AddEditModalNew: false,
            event_TrackID: false,
            edit_event: false,
        };
    }

    onMouseUp = () => {
        this.props.setClickedEventSegment(false);
    };

    render() {
        const duration = 300;
        const { tracks } = this.props;

        return (
            <>
                <StyledCard>
                    <div>
                        <StyledHeader>
                            <Typography variant="h5">
                                Weekly Planner
                                <div
                                    style={{
                                        float: "right",
                                        color: "#0288CC"
                                    }}
                                >
                                    <ReactToPrint
                                        onBeforePrint={() => {
                                            setTimeout(undefined, 2000);
                                        }}
                                        trigger={() => (
                                            <PrintIcon
                                                style={{
                                                    float: "right",
                                                    fontSize: "36px",
                                                    marginRight: "30px",
                                                    cursor: "pointer"
                                                }}
                                            />
                                        )}
                                        content={() => this.componentRef}
                                    />
                                </div>
                            </Typography>
                        </StyledHeader>
                        <StyledContent>
                            <Print ref={(el) => (this.componentRef = el)}>
                                <Fullscreen
                                    enabled={this.state.isFull}
                                    onChange={(isFull) => this.setState({ isFull })}
                                >
                                    <Button
                                        disabled={this.props.canCreate === false}
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            display: "inline-block",
                                            marginBottom: 12,
                                            marginRight: 12,
                                            background: "#0188cc",
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                track_modal: true,
                                                track_details: {
                                                    name: "",
                                                    area: "",
                                                    department: "",
                                                },
                                            });
                                        }}
                                    >
                                        <AddIcon /> Add Crew Track
                                    </Button>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            display: "inline-block",
                                            marginBottom: 12,
                                            marginRight: 12,
                                            background: "#0188cc",
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                isFull: !this.state.isFull,
                                            });
                                        }}
                                    >
                                        {(this.state.isFull && (
                                            <>
                                                <FSEIcon /> Exit Fullscreen
                                            </>
                                        )) || (
                                                <>
                                                    <FSIcon /> Enter Fullscreen
                                                </>
                                            )}
                                    </Button>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            display: "inline-block",
                                            marginBottom: 12,
                                            marginRight: 12,
                                            background: "#0188cc",
                                        }}
                                        onClick={() => {
                                            this.props.setIsLocked(!this.props.isLocked);
                                        }}
                                    >
                                        {(!this.props.isLocked && (
                                            <>
                                                <LockOpenIcon />
                                                 Unlocked
                                            </>
                                        )) || (
                                                <>
                                                    <LockIcon />
                                                    Locked
                                                </>
                                            )}
                                    </Button>{" "}
                                    <Select
                                        label={"Area Filter"}
                                        style={{
                                            width: "150px",
                                            display: "inline-block",
                                            marginBottom: 12,
                                            marginRight: 12,
                                        }}
                                        value={this.props.areaFilter}
                                        onChange={(e) => {
                                            this.props.setAreaFilter(e.target.value);
                                        }}
                                    >
                                        <MenuItem value={"all_areas"} key={"all_areas"}>
                                            All Areas
                                        </MenuItem>
                                        {this.props.areas &&
                                            Object.keys(this.props.areas).map((option) => {
                                                return (
                                                    <MenuItem
                                                        value={this.props.areas[option]}
                                                        key={option}
                                                    >
                                                        {this.props.areas[option]}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                    <Select
                                        label={"Department Filter"}
                                        style={{
                                            width: "150px",
                                            display: "inline-block",
                                            marginBottom: 12,
                                            marginRight: 12,
                                        }}
                                        value={this.props.depFilter}
                                        onChange={(e) => {
                                            this.props.setDepartmentFilter(e.target.value);
                                        }}
                                    >
                                        <MenuItem value={"all_departments"} key={"all_deps"}>
                                            All Department
                                        </MenuItem>
                                        {this.props.departments &&
                                            Object.keys(this.props.departments).map((option) => {
                                                return (
                                                    <MenuItem
                                                        value={this.props.departments[option]}
                                                        key={option}
                                                    >
                                                        {this.props.departments[option]}
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                    <div className="full-screenable-node">
                                        <StyledCardContent isFull={this.state.isFull}>
                                            <TimelineContainer
                                                weekCount={this.props.weekCount}
                                                onMouseUp={this.onMouseUp}
                                            >
                                                <DateRangeControlCell />

                                                {Array.isArray(this.props.weekDayStrings) &&
                                                    this.props.weekDayStrings.map((e, i) => {
                                                        return (
                                                            <DateCell key={i} day={i}>
                                                                <DateText
                                                                    weekCount={this.props.weekCount}
                                                                >
                                                                    {e}
                                                                </DateText>
                                                            </DateCell>
                                                        );
                                                    })}

                                                <AllTracksContainer
                                                    weekCount={this.props.weekCount}
                                                >
                                                    {tracks &&
                                                        tracks.map((e, i) => (
                                                            <Track
                                                                duration={duration}
                                                                id={e.track_id}
                                                                index={i}
                                                                row={i}
                                                                trackCount={tracks.length || 0}
                                                                addNewEvent={(
                                                                    track_id,
                                                                    department,
                                                                    area
                                                                ) => {
                                                                    this.setState({
                                                                        AddEditModalNew: true,
                                                                        AddEditModalOpen: true,
                                                                        event_TrackID: track_id,
                                                                        event_department: department,
                                                                        event_area: area,
                                                                    });
                                                                }}
                                                                editEvent={(track_id, event) => {
                                                                    this.setState({
                                                                        AddEditModalNew: false,
                                                                        edit_event: event,
                                                                    });
                                                                    this.setState({
                                                                        AddEditModalOpen: true,
                                                                        event_TrackID: track_id,
                                                                    });
                                                                }}
                                                                weekCount={this.props.weekCount}
                                                                sidebarWidth={180}
                                                                key={e.track_id}
                                                                name={e.name}
                                                                department={e.department}
                                                                area={e.area}
                                                                days={new Array(
                                                                    this.props.weekCount * 7
                                                                ).fill(false)}
                                                            />
                                                        ))}
                                                </AllTracksContainer>
                                            </TimelineContainer>
                                        </StyledCardContent>
                                    </div>
                                    <Modal isOpen={this.state.track_modal}>
                                        <ModalHeader
                                            style={{
                                                textAlign: "center",
                                                display: "inline-block",
                                            }}
                                        >
                                            {`${this.state.newTrack ? "New" : "Edit"} Track`}
                                        </ModalHeader>

                                        <ModalBody>
                                            <FormControl style={{ display: "block" }}>
                                                <TextField
                                                    label={"Track Name"}
                                                    style={{ minWidth: 200 }}
                                                    value={this.state.track_details.name}
                                                    onChange={(event) => {
                                                        let track = this.state.track_details;
                                                        track.name = event.target.value;

                                                        this.setState({
                                                            track_details: track,
                                                        });
                                                    }}
                                                />
                                            </FormControl>
                                            <FormControl style={{ display: "block" }}>
                                                <InputLabel>Track Area</InputLabel>
                                                <Select
                                                    style={{
                                                        minWidth: 200,

                                                        marginBottom: 12,
                                                        marginRight: 12,
                                                    }}
                                                    value={this.state.track_details.area}
                                                    onChange={(e) => {
                                                        let track = this.state.track_details;
                                                        track.area = e.target.value;

                                                        this.setState({
                                                            track_details: track,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value={""} key={"all_areas"}>
                                                        None
                                                    </MenuItem>
                                                    {this.props.areas &&
                                                        Object.keys(this.props.areas).map(
                                                            (option) => {
                                                                return (
                                                                    <MenuItem
                                                                        value={
                                                                            this.props.areas[option]
                                                                        }
                                                                        key={option}
                                                                    >
                                                                        {this.props.areas[option]}
                                                                    </MenuItem>
                                                                );
                                                            }
                                                        )}
                                                </Select>
                                            </FormControl>
                                            <FormControl style={{ display: "block" }}>
                                                <InputLabel>Track Department</InputLabel>
                                                <Select
                                                    style={{
                                                        minWidth: 200,

                                                        marginBottom: 12,
                                                        marginRight: 12,
                                                    }}
                                                    value={this.state.track_details.department}
                                                    onChange={(e) => {
                                                        let track = this.state.track_details;
                                                        track.department = e.target.value;

                                                        this.setState({
                                                            track_details: track,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value={""} key={"all_areas"}>
                                                        None
                                                    </MenuItem>
                                                    {this.props.departments &&
                                                        Object.keys(this.props.departments).map(
                                                            (option) => {
                                                                return (
                                                                    <MenuItem
                                                                        value={
                                                                            this.props.departments[
                                                                            option
                                                                            ]
                                                                        }
                                                                        key={option}
                                                                    >
                                                                        {
                                                                            this.props.departments[
                                                                            option
                                                                            ]
                                                                        }
                                                                    </MenuItem>
                                                                );
                                                            }
                                                        )}
                                                </Select>
                                            </FormControl>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button
                                                onClick={() => {
                                                    this.setState({ track_modal: false });
                                                }}
                                                variant="contained"
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    let track = this.state.track_details;
                                                    if (this.state.newTrack) {
                                                        track.track_id = Date.now().toString();
                                                        track.timestamp = moment().format(
                                                            "DD-MM-YYYY HH:mm:ss"
                                                        );
                                                        this.props.setTrack(track);
                                                    } else {
                                                        this.props.setTrack(track);
                                                    }

                                                    this.setState({
                                                        track_modal: false,
                                                        track_details: false,
                                                    });
                                                }}
                                                color="primary"
                                                variant="contained"
                                            >
                                                Submit
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                    {this.state.AddEditModalOpen && (
                                        <AddEditEventModal
                                            isOpen={this.state.AddEditModalOpen}
                                            isNewEvent={this.state.AddEditModalNew}
                                            track_id={this.state.event_TrackID}
                                            department={this.state.event_department}
                                            area={this.state.event_area}
                                            edit_event={this.state.edit_event}
                                            closeModal={() => {
                                                this.setState({
                                                    AddEditModalOpen: false,
                                                    event_TrackID: false,
                                                    AddEditModalNew: false,
                                                });
                                            }}
                                        />
                                    )}
                                </Fullscreen>
                            </Print>
                        </StyledContent>
                    </div>
                </StyledCard>
            </>
        );
    }
}

export default hot(module)(
    React.memo(
        connect(
            (store) => {
                return {
                    weekCount: selectWeekCount(store),
                    weekDayStrings: selectWeekDayStrings(store),
                    isLocked: selectIsLocked(store),
                    tracks: selectTracks(store),
                    areas: selectAreas(store),
                    areaFilter: selectAreaFilter(store),
                    depFilter: selectDepartmentFilter(store),
                    departments: selectDepartments(store),
                    canCreate: canCreate(store),
                    canDelete: canDelete(store),
                    canUpdate: canUpdate(store),
                };
            },
            {
                getUsers,

                setClickedEventSegment,
                initialise,
                getVehicles,
                getEquipment,
                setAreaFilter,
                setDepartmentFilter,
                getDepartments,
                getAreas,
                getIsLocked,
                setTrack,
                getPlannerInfo,
                setIsLocked,
            }
        )(WeekPlannerV2)
    )
);
